import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import { StyleSheet, Text, View } from './base_components';
import type { Options as ChartOptions, SeriesOptionsType } from 'highcharts';
import ProgressSpinner from './progress_spinner';
import util from '../tools/util';

export { ChartOptions, SeriesOptionsType };

require('../css/chart.css');

const styles = StyleSheet.create({
  chart: { flexDirection: 'column', boxShadow: '0px 1px 1px rgba(0,0,0,0.5)' },
  topBar: {
    padding: '2rem',
    alignSelf: 'stretch',
    flexDirection: 'column',
    backgroundColor: '#fafafa',
    borderBottomWidth: 1,
    borderBottomColor: '#ededeb',
  },
  title: { color: '#17191e', fontSize: '1.7rem' },
  detail: { marginTop: '1rem', color: '#545b64', fontSize: '1.2rem' },
  chartView: {
    padding: '1rem',
    flex: 1,
    alignSelf: 'stretch',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spinner: {},
});

type Props = {
  style?: any;
  className?: string;
  title: string;
  detail: string;
  options: ChartOptions | null;
};
export default function Chart(props: Props) {
  const { options } = props;
  const [highcharts, setHighcharts] = React.useState<any>();
  React.useEffect(() => {
    import('highcharts').then(
      (lib) => {
        setHighcharts(lib);
      },
      (e) => {
        util.errorLog('Chart: failed to import highcharts');
      }
    );
  }, []);

  if (options) {
    options.title = { text: undefined };
    options.credits = { enabled: false };
    options.accessibility = { enabled: false };
  }

  return (
    <View style={[styles.chart, props.style]}>
      <View style={styles.topBar}>
        <Text style={styles.title}>{props.title}</Text>
        <Text style={styles.detail}>{props.detail}</Text>
      </View>
      <View style={styles.chartView}>
        {highcharts && options ? (
          <HighchartsReact highcharts={highcharts} options={options} />
        ) : (
          <ProgressSpinner style={styles.spinner} color='#999' />
        )}
      </View>
    </View>
  );
}
